import * as React from 'react'
import {CardBody, CardImg, Col, Row} from "reactstrap";
import {Spinner} from "App/fragments/Spinner";
import {connect} from "react-redux";
import {WithTranslation, withTranslation} from "react-i18next";
import {ConfiguratorProduct, ConfiguratorProductTypes} from "App/services/api";
import {UserState} from "App/user";
import {Basket} from "App/basket";
import {ReactNode} from "react";
import {formatPhone, selectedLang} from "App/helper";
import {Language} from "App/constants";

export interface ComponentProps {
    user: UserState|null
    basket: Basket
    configuration: ConfiguratorProduct
}



class _Component extends React.PureComponent<ComponentProps & WithTranslation> {

    constructor(props: ComponentProps & WithTranslation, context: any) {
        super(props, context);
        this.mailTo = this.mailTo.bind(this);
    }

    mailTo(email: string, subject: string): ReactNode {
        return <React.Fragment>
            <i className="far fa-envelope action d-inline"></i>
            <a className={'action pl-2 text-normal-overview d-inline'} href={"mailto:"+ email + "?subject="+encodeURIComponent(subject)}>{email}</a>
        </React.Fragment>
    }

    phoneTo(phone: string): ReactNode {
        return <React.Fragment>
            <i className="far fa-phone fa-flip-horizontal action d-inline"></i>
            <a className={'action pl-2 text-normal-overview d-inline'} href={"tel:"+ phone}>{formatPhone(phone)}</a>
        </React.Fragment>
    }

    render() {
        const { t, i18n, user, basket, configuration } = this.props;
        const language: Language = selectedLang(i18n);
        const chosenType: ConfiguratorProductTypes | undefined = configuration.types&&configuration.types.find((type:ConfiguratorProductTypes) => type.typeid===basket.machineid);
        const subject: string = t('products.configuration.emailsubject', {product: chosenType?chosenType.name:configuration.nameml[language]});
        return (
            user&&user.CUNO?
                (basket.salesman?
                        <CardBody>
                            <Row className="align-items-left no-gutters">
                                <Col className={"d-flex flex-column text-left text-normal-overview" }>
                                    {t('products.configuration.salesman')}
                                </Col>
                            </Row>
                            <Row>
                                <Col className={basket.salesman.portraiturl?"col-3 col-sm-2 col-lg-3 pr-0":"d-none"}>
                                    <CardImg src={basket.salesman.portraiturl} className="px-0 pt-2 rounded"/>
                                </Col>
                                <Col className={basket.salesman.portraiturl?"col-9 col-sm-8 col-lg-9":"col-12"}>
                                    <Row className="align-items-left no-gutters">
                                        <Col className={"d-flex pt-2 flex-column text-left text-normal-details" }>
                                            {basket.salesman.name}
                                        </Col>
                                    </Row>
                                    <Row className="align-items-left no-gutters">
                                        <Col className={"d-flex pt-2 text-left align-items-center" }>{this.phoneTo(basket.salesman.phone)}</Col>
                                    </Row>
                                    <Row className="align-items-left no-gutters">
                                        <Col className={"d-flex pt-1 text-left align-items-center" }>{this.mailTo(basket.salesman.email, subject)}</Col>
                                    </Row>
                                </Col>
                            </Row>
                        </CardBody>:
                        <CardBody>
                            <Spinner active={basket.syncState.pending}/>
                        </CardBody>
                ):
                <CardBody>
                    <Row className="align-items-left no-gutters">
                        <Col className={"d-flex flex-column text-left text-normal-overview" }>
                            {t('products.configuration.productmanager')}
                        </Col>
                        <Col className={configuration.productmanager.portraiturl?"col-3 col-sm-2 col-lg-3 pr-0":"d-none"}>
                            <CardImg src={configuration.productmanager.portraiturl} className="px-0 pt-2 rounded"/>
                        </Col>
                    </Row>
                    <Row>
                        <Col className={configuration.productmanager.portraiturl?"col-9 col-sm-8 col-lg-9":"col-12"}>
                            <Row className="align-items-left no-gutters">
                                <Col className={"d-flex pt-2 flex-column text-left text-normal-details" }>
                                    {configuration.productmanager.name}
                                </Col>
                            </Row>
                            <Row className="align-items-left no-gutters">
                                <Col className={"d-flex pt-2 text-left align-items-center" }>{this.phoneTo(configuration.productmanager.phone)}</Col>
                            </Row>
                            <Row className="align-items-left no-gutters">
                                <Col className={"d-flex pt-1 text-left align-items-center" }>{this.mailTo(configuration.productmanager.email, subject)}</Col>
                            </Row>
                        </Col>
                    </Row>
                </CardBody>
        )}
}

export const ContactInfo = connect(null, null)(withTranslation('common')(_Component));


// WEBPACK FOOTER //
// ./src/components/ContactInfo.tsx